'use client';
import { useParams } from 'next/navigation';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import { doTranslation } from '@/app/i18n/client';
import { default as Image } from '@/components/global/images/resized-cdn-image';
import Tooltip from '@/components/global/tooltip/tooltip';
import styles from '@/components/global/carrier-logo/carrier-logo.module.scss';
import { CarrierImage } from '@/utils/carriers';

type Props = {
  carrierImage: CarrierImage;
  height?: number;
  width?: number;
};

const CarrierLogo = (props: Props) => {
  const { lng }: any = useParams();

  const { t } = doTranslation(lng);
  const carrierImage = props.carrierImage;
  const src = carrierImage.src;
  const height = props.height ?? 20;
  const width = props.width ?? Math.round(height * carrierImage.width / carrierImage.height);
  const alt = carrierImage.carrierName;
  const tooltipContent = carrierImage.carrierName;

  return (
    <span className={styles.carrier}>
      <Tooltip
        ariaLabelOpen={t('Carrier name')}
        ariaLabelClose={t('Carrier name')}
        content={tooltipContent}
        hover={true}
        id={uuidv4()}
        place="top"
        tabIndex={0}
        wrap={true}
      >
          <Image alt={alt} src={src} height={height} width={width} />
      </Tooltip>
    </span>
  );
};

export default CarrierLogo;
